module.exports = __webpack_public_path__ + "static/media/LeftAlignBlack.3cc99cd1.svg";